const ErrorTextBox = (props: any) => {
  return (
    <div style={{ color: '#d32f2f', textAlign: 'left', fontSize: '11px', marginTop: '3px' }}>
      {props.children}
    </div>
  );
};

export default ErrorTextBox;
